


















































import Vue from 'vue';
import isGranted from '@/auth/isGranted';
import { DetailedEmailCampaign } from '@/types';
import ReportOverview from './ReportOverview.vue';
import Summary from './Summary.vue';
import Opens from './Opens.vue';
import Clicks from './Clicks.vue';
import LinkActivities from './LinkActivities.vue';
import Unsubscribers from './Unsubscribers.vue';
import Bounces from './Bounces.vue';
import DownloadReportPdfBtn from './DownloadReportPdfBtn.vue';

export default Vue.extend({
  props: {
    emailCampaign: {
      type: Object as () => DetailedEmailCampaign,
      required: true,
    },
  },
  data() {
    return {
      tab: 'overview',
    };
  },
  methods: {
    isGranted,
  },
  components: {
    'report-overview': ReportOverview,
    'report-summary': Summary,
    opens: Opens,
    clicks: Clicks,
    'link-activities': LinkActivities,
    unsubscribers: Unsubscribers,
    bounces: Bounces,
    'download-report-pdf-btn': DownloadReportPdfBtn,
  },
});
